"use client";

import { Col, Container, Row } from "react-bootstrap";
import "./MeasurableSection.scss";
import Image from "next/image";

const MeasurableSection = ({ measurable }) => {
  if (!measurable) return null;
  const { title, description, features = [] } = measurable;

  const renderHighlightedTitle = (titleText = "") => {
    const parts = titleText.split(/(".*?")/g);

    return parts.map((part, index) => {
      if (part.startsWith('"') && part.endsWith('"')) {
        return (
          <span key={index} className="highlight-font">
            {part.slice(1, -1)}
          </span>
        );
      }

      return part;
    });
  };

  return (
    <section className="measurable-section">
      <Container>
        <div className="measurable-header">
          <h2 className="measurable-title">{renderHighlightedTitle(title)}</h2>
          <p className="measurable-description">{description}</p>
        </div>
        <Row className="features-grid g-4">
          {features.map((feature, index) => (
            <Col key={index} lg={3} md={6} className="measurable-item">
              <div className="measurable-card">
                <div className="measurable-icon">
                  <Image
                    src={feature.icon}
                    alt={feature.title}
                    width={48}
                    height={48}
                  />
                </div>
                <div className="measurable-content">
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default MeasurableSection;
